import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-4 text-center mt-6">
      <p>© 2025 ग्रामपंचायत गोंडीडीग्रास
 | संपर्क: 9765088087</p>
    </footer>
  );
};

export default Footer;